import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

const Previewcomponent = ({ attachments, handleOpen }) => {
  return (
    <div className="flex flex-wrap gap-4">
      {attachments &&
        attachments.map((item, index) => (
          <div className="my-2" key={index}>
            {item?.fileExt?.includes(".jpg") ||
            item?.url?.includes(".jpg") ||
            item?.fileExt?.includes(".webp") ||
            item?.url?.includes(".webp") ||
            item?.fileExt?.includes(".jpeg") ||
            item?.url?.includes(".jpeg") ||
            item?.fileExt?.includes(".png") ||
            item?.url?.includes(".png") ? (
              <LazyLoadImage
                src={item.url}
                alt={item.fileName}
                effect="blur"
                width="100%"
                height="auto"
                placeholderSrc={item.url}
                onClick={() => {
                  if (
                    item?.fileExt?.match(/\.(jpg|jpeg|png|webp)$/i) ||
                    item?.url?.match(/\.(jpg|jpeg|png|webp)$/i)
                  ) {
                    handleOpen(
                      item?.url || item?.path,
                      item?.generatedAt || item?.createdAt,
                      index,
                      attachments
                    );
                  }
                }}
                className="w-16 h-16 object-cover rounded cursor-pointer border border-gray-300 hover:scale-105 transition-transform duration-200"
              />
            ) : // <img
            //   src={item?.url || item?.path}
            //   alt="Preview"
            //   loading="lazy"
            //   onClick={() =>
            //     handleOpen(
            //       item?.url || item?.path,
            //       item?.generatedAt || item?.createdAt
            //     )
            //   }
            //   className="w-16 h-16 object-cover rounded cursor-pointer border border-gray-300 hover:scale-105 transition-transform duration-200"
            // />
            item?.fileExt?.includes(".pdf") || item?.url?.includes(".pdf") ? (
              <iframe
                src={`https://docs.google.com/gview?url=${item?.url}&embedded=true`}
                width="100%"
                height="160px"
                loading="lazy"
              />
            ) : item?.fileExt?.includes(".mp4") ||
              item?.url?.includes(".mp4") ||
              item?.fileExt?.includes(".mov") ||
              item?.url?.includes(".mov") ||
              item?.fileExt?.includes(".avi") ||
              item?.url?.includes(".avi") ||
              item?.fileExt?.includes(".wmv") ||
              item?.url?.includes(".wmv") ? (
              <video preload="none" className="h-40 rounded" controls>
                <source src={item?.url} type="video/mp4" />
              </video>
            ) : (
              <p className="text-gray-500 text-center mt-4 italic">
                No image available
              </p>
            )}
          </div>
        ))}
    </div>
  );
};

export default Previewcomponent;
